import { create } from "zustand";

interface PremiumSubscriptionStore {
  isPremiumModalOpen: boolean;
  openPremiumModal: () => void;
  closePremiumModal: () => void;
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
  subscribe: () => Promise<void>;
}

export const usePremiumStore = create<PremiumSubscriptionStore>((set) => ({
  // Modal state
  isPremiumModalOpen: false,
  isLoading: false,

  // Actions
  openPremiumModal: () => set({ isPremiumModalOpen: true }),
  closePremiumModal: () => set({ isPremiumModalOpen: false }),

  setLoading: (loading: boolean) => set({ isLoading: loading }),

  subscribe: async () => {
    set({ isLoading: true });

    try {
      await new Promise((resolve) => setTimeout(resolve, 1500));

      set({ isLoading: false, isPremiumModalOpen: false });
    } catch (error) {
      set({ isLoading: false });
      console.error("Subscription failed:", error);
    }
  },
}));
